import { render, staticRenderFns } from "./ExportPartnerInformation.vue?vue&type=template&id=064eb37a&"
import script from "./ExportPartnerInformation.vue?vue&type=script&lang=js&"
export * from "./ExportPartnerInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports